<form [formGroup]="paymentForm" (ngSubmit)="onSubmit()" class="re-relative" [attr.aria-label]="'aria.form.bankingData' | translate">
  <div class="bdo-container--single">
    <div [class.re-mb-15]="state === LoadingState.ERROR">
      @if (state === LoadingState.ERROR) {
        <bdo-info-box class="bdo-container--single">
          {{ 'general.error.error' | translate }}
        </bdo-info-box>
      }
    </div>
  </div>
  @if (state === LoadingState.LOADING) {
    <bdo-loading></bdo-loading>
  }

  <div class="re-form-item-container">
    {{ 'personaldata.banking.sepaInfo' | translate }}
  </div>

  @if (state !== LoadingState.LOADING) {
    <fieldset name="banking-details" class="re-mb-0" [attr.aria-label]="'aria.fieldset.bankingInformation' | translate">
      <!-- Only require sepa checkbox if not set before -->
      @if (!formWithSepaBox) {
        <bdo-bank-account-form [parentForm]="paymentForm"></bdo-bank-account-form>
      } @else {
        <bdo-sepa-form #sepaForm
          [parentForm]="paymentForm"
          [sepaRequired]="true"
        ></bdo-sepa-form>
      }
      <div class="re-form-item-container bdo-space--bottom re-mt-25 re-mb-15">
        <button class="bdo-button-primary bdo-button--text" data-qa="submit" type="submit">
          {{ 'general.action.save' | translate }}
        </button>
      </div>
      <button type="button" class="bdo-nolink" (click)="cancel.emit()">
        <div class="bold">{{ 'general.action.cancel' | translate }}</div>
      </button>
    </fieldset>
  }
</form>
